import React from "react";
import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";
import { usePlatformTranslation } from "@/hooks/usePlatformTranslation";

export interface CommentsButtonProps {
  onClick: () => void;
}

/**
 * Comments button component.
 */
export function CommentsButton({ onClick }: CommentsButtonProps) {
  const { t } = usePlatformTranslation();

  return (
    <Button
      variant="ghost"
      size="sm"
      className="p-2 text-muted-foreground hover:text-foreground hover:bg-muted"
      onClick={onClick}
      title={t('platform.cards.widgets.comments')}
    >
      <MessageSquare className="h-4 w-4" />
    </Button>
  );
}

export default CommentsButton;

